import React from 'react';
import { textSerifTitle2, textTitle3 } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

export interface BlogAskADemoTextProps extends DefaultBsComponent {
  type?: 'text' | 'image';
}

export const BlogAskADemoZoneText = ({
  children,
  className,
  as: Component = 'div',
  type,
  ...props
}: BlogAskADemoTextProps) => {
  return (
    <Component
      {...props}
      className={classNames(
        'BlogAskADemoZoneText',
        className,
        type === 'image' ? textSerifTitle2 : textTitle3,

        'text-left',
        'max-w-[294px]'
      )}
    >
      {children}
    </Component>
  );
};
